// extracted by mini-css-extract-plugin
export default {"tabs":"j8-z","tablist":"k8-z","tablistItem":"l8-z"};